export default "__VITE_ASSET__Cl_4ZP6H__"